/**
 * "College Scholarship Program" section of the Ryerson Gives Back page
 * (`src/pages/why-ryerson/ryerson-commitment/ryerson-gives-back/index.tsx`, its only importer).
 * It has no layout of its own: it renders the Environment, Health & Safety image-and-text layouts
 * from `../../EnvironmentHealthSafety/CommunicationAndSafety/` (`CommunicationAndSafetyDesktop.tsx`
 * from `lg` up, `CommunicationAndSafetyMobile.tsx` below) with the copy in
 * `./CollegeScholarshipProgrammeContent.tsx`, so a change to those layouts changes this section.
 *
 * The component inside this file is named `CommunicationAndSafety`; the page imports the default
 * export as `CollegeScholarshipProgramme`.
 */
import React from "react";
import { Media } from "@ryerson/frontend.next";
import CommunicationAndSafetyDesktop from "../../EnvironmentHealthSafety/CommunicationAndSafety/CommunicationAndSafetyDesktop";
import { CollegeScholarshipProgrammeContent } from "./CollegeScholarshipProgrammeContent";
import CommunicationAndSafetyMobile from "../../EnvironmentHealthSafety/CommunicationAndSafety/CommunicationAndSafetyMobile";
import { useApplication } from "@ryerson/frontend.application";

/** Renders the section in the visitor's language, falling back to English. Takes no props. */
const CommunicationAndSafety: React.FC = () => {
	const {
		localization: { language },
	} = useApplication();

	const collegeScholarshipProgrammeContent =
		CollegeScholarshipProgrammeContent[language] || CollegeScholarshipProgrammeContent.en;

	return (
		<>
			<Media lessThan="lg">
				<CommunicationAndSafetyMobile content={collegeScholarshipProgrammeContent} />
			</Media>
			<Media greaterThanOrEqual="lg">
				<CommunicationAndSafetyDesktop content={collegeScholarshipProgrammeContent} />
			</Media>
		</>
	);
};

export default CommunicationAndSafety;
